import React from "react";
import { Map } from "immutable";
import { get } from "lodash";
import T from "prop-types";
import { ToggleSwitch } from "MODULES/shared/containers";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { DropDownItem, Icon } from "MODULES/shared/components";
import * as actions from "MODULES/SalesOrders/actions";
import { EditInvoiceDetailsForm } from "MODULES/Orders/shared/EditInvoiceDetailsForm";
import {
  BROKERED_EXCHANGE,
  CORE_REPAIR_INVOICE_AMOUNT_PAID,
  FLAT_EXCHANGE,
  PAID_IN_FULL,
  REPAIR_ADMINISTRATION_FEE,
  SALES_ORDER
} from "MODULES/SalesOrders/constants";
import { ORIGINAL_EVALUATION } from "MODULES/RepairOrders/constants";

const coreRepairCharge = lineItem => {
  const originalEval = get(
    lineItem,
    ["most_recent_repair_item", ORIGINAL_EVALUATION].join("."),
    0
  );

  const adminFee = get(lineItem, REPAIR_ADMINISTRATION_FEE, 0);

  return Number(originalEval) + Number(adminFee);
};

function EditInvoiceDetails({ salesOrder }) {
  salesOrder.line_items = salesOrder.line_items.map(lineItem => ({
    ...lineItem,
    [CORE_REPAIR_INVOICE_AMOUNT_PAID]:
      lineItem[BROKERED_EXCHANGE] || lineItem[FLAT_EXCHANGE]
        ? salesOrder[CORE_REPAIR_INVOICE_AMOUNT_PAID]
        : coreRepairCharge(lineItem),
    [PAID_IN_FULL]: Number(lineItem.amount_paid) === Number(lineItem.subtotal)
  }));

  if (
    salesOrder.line_items.filter(l => !l.cancelled || l.shipped).length === 0
  ) {
    return null;
  }

  return (
    <ToggleSwitch>
      {(visible, open, close) => (
        <DropDownItem onClick={open}>
          <Icon name="dollar" fixed />
          &nbsp;Edit Billing
          <Modal open={visible} close={close} dialogClass="modal-lg">
            <Header>
              <Close close={close} />
              <h4 className="modal-title">Edit Billing Details</h4>
            </Header>
            <EditInvoiceDetailsForm
              close={close}
              orderType={SALES_ORDER}
              displaySerial
              order={salesOrder}
              initialValues={Object.assign(salesOrder, {
                invoice_paid_date: null,
                invoice_number: null
              })}
              includeCancelled
              bulkUpdate={actions.bulkUpdateLineItems}
            />
          </Modal>
        </DropDownItem>
      )}
    </ToggleSwitch>
  );
}

export default EditInvoiceDetails;

EditInvoiceDetails.propTypes = {
  salesOrder: T.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/EditInvoiceDetails/EditInvoiceDetails.jsx